import { render, staticRenderFns } from "./lkuApprepaid.vue?vue&type=template&id=50ae2146"
import script from "./lkuApprepaid.vue?vue&type=script&lang=js"
export * from "./lkuApprepaid.vue?vue&type=script&lang=js"
import style0 from "./lkuApprepaid.vue?vue&type=style&index=0&id=50ae2146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports